
  import {defineComponent, onMounted, PropType, reactive, toRefs, watch} from "vue";
  import CustomerOrdersUpcoming from "@/views/Customers/orders/CustomerOrdersUpcoming.vue";
  import CustomerOrdersPast from "@/views/Customers/orders/CustomerOrdersPast.vue";
  import {customerId} from "@/RouterUtils";
  import CustomerService from "@/service/CustomerService";
  import PageUtils from "@/components/PageUtils";
  import router from "@/router";
  import Customer from "@/model/Customer";
  import PlanOrderDialog from "@/views/Customers/orders/PlanOrderDialog.vue";
  import CustomerOrderService, {CustomerOrder} from "@/service/CustomerOrderService";
  import DateUtils from "@/DateUtils";

  export default defineComponent({
    name: "CustomerOrders",
    components: {
      PlanOrderDialog,
      CustomerOrdersUpcoming,
      CustomerOrdersPast
    },
    props: {
      customer: {
        type: Object as PropType<Customer>,
        default: () => new Customer(),
      }
    },
    setup(props, context) {

      const initialState = {
        panel: [0, 1],
        loading: false,
        loadingUpcoming: false,
        past: [],
        upcoming: new Array<CustomerOrder>(),
        planOrderDialog: false,
        pastOrdersAvgPos: 0
      };
      const state = reactive({...initialState});

      const newOrder = () => {
        router.push({ path: `/orders/new?customerId=${customerId.value}` });
      };
      const planOrder = () => {
        state.planOrderDialog = true;
      };
      const savePlanOrder = (positions: number) => {
        if (positions) {
          router.push({ path: `/v2/orders?customerId=${customerId.value}&positions=${positions}` });
          state.planOrderDialog = false;
        }
      };
      const closePlanOrder = () => {
        state.planOrderDialog = false;
      };

      onMounted(() => {
        state.loading = true;
        CustomerService.getOrders(customerId.value)
          .then(response => {
            state.past =  PageUtils.extractCollection(response.data, "past");
          })
          .finally(() =>  state.loading = false);
      });

      // The upcoming orders are the inventory orders starting today or later
      watch(() => props.customer.uuid, customerUuid => {
        if (!customerUuid) {
          return;
        }
        state.loadingUpcoming = true;
        CustomerOrderService.findInventoryOrdersStartingFrom(customerUuid, DateUtils.today())
          .then(response => {
            state.upcoming = response.data.orders;
          })
          .finally(() => state.loadingUpcoming = false);
      }, {immediate: true});

      const pastOrdersAvgPosChanged = (pastOrdersAvgPos: number) => {
        state.pastOrdersAvgPos = pastOrdersAvgPos;
      };

      return {
        ...toRefs(state),
        customerId,
        newOrder,
        planOrder,
        savePlanOrder,
        closePlanOrder,
        pastOrdersAvgPosChanged
      };
    }
  });
